<template>
<plan :features="features">
    <template v-slot:name>Free</template>
    <template v-slot:price>0</template>
    <template v-slot:description>Single inbox support</template>
    <template v-slot:frequency>
        <button class="font-bold py-2 my-4 px-4 text-gray-darker cursor-default" disabled>Forever</button>
    </template>

    <template v-slot:action>
        <picker-button :selected="isCurrent" @click.native="pick">Choose</picker-button>
    </template>

</plan>
</template>

<script>
export default {
    props: {
        current: {
            type: String,
            required: false,
        },
        features: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            id: 'free',
        }
    },
    computed: {
        isCurrent() {
            // show the free plan as currently active plan if there's no subscribed plan
            return !this.current;
        },
    },
    methods: {
        pick() {
            this.$emit('picked');
        }
    }
}
</script>
